import { ButtonColor, ButtonVariant, useModal } from '@ampol/design-system';
import { EditConfirmChanges } from '../../edit-multiple-card/edit-multiple-card';
import { useSelectMultiEditCardFormValues, useSelectMultiEditSelectedCards } from './MutliEditCardFormSlice';
import { CardModalFormNames } from '../types/CardModalFormNames';

/**
  * Used as the final step before submitting the changes in the multi edit modal
 */
export default function useMultiEditConfirmModal(
  onConfirm: () => void,
) {
  const edittedCardValues = useSelectMultiEditCardFormValues();
  const selectedCards = useSelectMultiEditSelectedCards();

  const mappedCards = edittedCardValues.map((values, index) => ({
    contractNumber: selectedCards?.[index]?.parent,
    contractIdentifier: selectedCards?.[index]?.cardNumber,
    driverName: values?.[CardModalFormNames.DriverName],
  }));

  const multiEditConfirmModal = useModal({
    id: 'multi-edit-confirm-card-modal',
    color: ButtonColor.Blue,
    title: 'Edit Card',
    subtitle: 'Confirm Changes',
    variant: 'double',
    content: <EditConfirmChanges cardList={mappedCards} />,
    actions: [
      {
        label: 'Submit',
        variant: ButtonVariant.Primary,
        onClick: () => {
          onConfirm();
          multiEditConfirmModal.clear();
        },
      },
      {
        label: 'Back',
        variant: ButtonVariant.Secondary,
        onClick: () => {
          multiEditConfirmModal.close();
        },
      },
    ],
  });

  return multiEditConfirmModal;
}